var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 40,
    viewBox: "0 0 175 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_fun-underline (1) 1",
    clipPath: "url(#clip0_87_8271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.82951 8.73002C46.3468 7.44826 90.8642 6.16647 135.382 4.88471C147.981 4.52195 160.58 4.15917 173.179 3.79641V0.0010707C150.858 2.67251 128.689 6.50606 106.781 11.5577C101.364 12.8067 95.964 14.1282 90.582 15.5202C87.9215 16.2083 84.7305 16.6332 82.2066 17.7486C81.0064 18.279 80.1795 18.9608 79.9969 20.3294C79.4206 24.6506 85.5609 24.0673 88.1592 24.4455C93.563 25.2319 98.8583 26.5478 104.045 28.247V24.5872C101.909 25.2836 99.774 25.9799 97.6385 26.6763C95.8282 27.2666 93.6639 27.6916 92.1335 28.8808C90.0378 30.509 89.3188 33.368 90.2033 35.8488C91.4409 39.3197 94.6155 39.8596 97.8821 39.9979C100.321 40.1012 100.317 36.3057 97.8821 36.2026C95.9636 36.1213 92.214 35.4015 93.9096 32.4792C94.5071 31.4495 96.0134 31.1946 97.0576 30.8541C99.7226 29.9851 102.388 29.116 105.053 28.247C106.852 27.6601 106.851 25.1763 105.053 24.5872C100.602 23.1291 96.0742 21.9493 91.4574 21.1514C89.5782 20.8267 87.688 20.5619 85.7933 20.3462C85.2192 20.2784 84.6444 20.218 84.0688 20.165C84.0534 21.0556 84.3663 21.3077 85.0077 20.9212C85.7931 21.0642 87.1732 20.3391 87.9982 20.1205C97.3486 17.6424 106.756 15.3795 116.211 13.3366C135.04 9.2681 154.053 6.08548 173.179 3.79641C175.531 3.5149 175.681 -0.0709649 173.179 0.0010707C128.662 1.28286 84.1446 2.56462 39.6272 3.84641C27.028 4.20917 14.4287 4.57195 1.82951 4.93471C-0.604792 5.0048 -0.614876 8.80042 1.82951 8.73002Z",
    fill: "#E9AF02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_8271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.7ce02096f94757bddf7b2916304ace48.svg";
export { ForwardRef as ReactComponent };